var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            border: "",
            "header-cell-style": {
              backgroundColor: "#FDEFE7",
              color: "#000000",
            },
            data: _vm.tableData,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "left",
              align: "center",
              prop: "orderMainId",
              label: "订单编号",
              width: "180",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "name",
              label: "下单时间",
              width: "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("dateFormatHms")(scope.row.createTime)) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "address",
              label: "用户账号",
              width: "180",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "name",
              label: "用户昵称 机构名称 用户联系电话",
              width: "200",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("p", [
                      _vm._v("用户昵称：" + _vm._s(scope.row.createName)),
                    ]),
                    _c("p", [
                      _vm._v("机构名：" + _vm._s(scope.row.createCompanyName)),
                    ]),
                    _c("p", [
                      _vm._v("联系电话：" + _vm._s(scope.row.phoneNumber)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", prop: "address", label: "支付方式" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " + _vm._s(_vm.payModeType[scope.row.payMode]) + " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", prop: "address", label: "订单来源" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          scope.row.orderType == 0 ? "pc端订单" : "小程序订单"
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            border: "",
            "header-cell-style": {
              backgroundColor: "#FDEFE7",
              color: "#000000",
            },
            data: _vm.tableData,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "left",
              align: "center",
              prop: "planId",
              label: "行程编号",
              width: "180",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "budgetMainId",
              label: "预算编号",
              width: "180",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "address",
              label: "子订单数量",
              width: "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _vm._l(scope.row.statusDescription, function (n, m) {
                    return _c(
                      "div",
                      {
                        key: m,
                        staticStyle: {
                          "font-size": "0.12rem",
                          "margin-bottom": "0.05rem",
                        },
                      },
                      [
                        _c("span", { staticStyle: { color: "#3A8477" } }, [
                          _vm._v(_vm._s(n.num) + "个子订单"),
                        ]),
                      ]
                    )
                  })
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", prop: "address", label: "订单可得积分" },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "address",
              label: "订单可得成长值",
            },
          }),
          _c("el-table-column", {
            attrs: { align: "center", prop: "address", label: "活动信息" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }